<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-end" v-if="(!editForm) && $can(abilities.UPDATE_PROJECT)">
        <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="projects.edit_description" size="7px 30px" @click="editDetail"></Button>
      </div>
      <div class="ms-5" v-if="!editForm">
        <div class="form-group mt-5">
          <label class="form-label fs-3 text-gray">{{ $t('projects.description') }}</label>
          <div class=" min-h-100px back" v-html="formEditData.description"></div>
        </div>
      </div>
      <div v-if="editForm">
        <CKEditor 
          id="detail-editor" 
          ktClass="h-50px"
          v-model="formEditData.description"
        />
        <TagifyInput
          containerClass="col-12 mt-5 mb-5"
          type="text"
          :label="$t('projects.label.keywords')"
          labelClass="form-label"
          :inputClass="'form-control form-control-lg form-control-solid'"
          :isRequired="false" size="lg"
          v-model="formEditData.key_word"
          name="keyword"
          :helper-text="$t('attributes.tag_input_text')"
        />
      </div>
    </div>
    <div v-if="editForm" class="card-footer">
      <div class="d-flex justify-content-end">
        <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click="editDetail"></Button>
        <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" @click="updateProject" :is-loading="isLoading"></Button>
      </div>
    </div>
  </div>
</template>

<script setup> 
import {ref, watch, defineEmits} from "vue";
import {useStore} from "vuex";
import Button from "@/components/Button";
import i18n from "@/plugins/i18n";
import CKEditor from "@/components/CKEditor2.vue";
import TagifyInput from "@/components/TagifyInput.vue";
import abilities from "@/composables/abilities";

const store = useStore()

const props = defineProps({
  form: {
    type: Object,
    required: true
  }
})
 
const emits = defineEmits(['reload'])

const editForm = ref(false)
const isLoading = ref(false)

const formEditData = ref({...props.form})

watch(() => props.form, (value) => {
  if(value) formEditData.value = props.form
}, {deep: true})

function editDetail(){
  editForm.value = !editForm.value
}



function updateProject() {
  isLoading.value = true
  store.dispatch('projects/updateProject', formEditData.value)
      .then((res) => {
        emits('reload')
        editDetail()
        window.toastr.success(i18n.global.t("projects.project_updated_successfully"))
      })
      .catch()
      .finally(() => isLoading.value = false)
}
</script>
<style scoped>
.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 10px;
  width: auto;
}
</style>